import React from 'react';
import { RiAddLine, RiShieldCheckLine } from '@remixicon/react';
import { useLocation } from 'wouter';
import { isReadOnly } from '../../config.ts';

type ActionButtonProps = {
  icon?: React.ReactNode;
  text: string;
  route?: string;
  onClick?: () => void;
  disabled?: boolean;
};

const ActionButton: React.FC<ActionButtonProps> = ({ icon, text, route, onClick, disabled }) => {
  const [, setLocation] = useLocation();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (route) {
      setLocation(route);
    }
  };

  return (
    <button
      className="flex items-center gap-2 px-4 py-2 mt-4 rounded-lg bg-cta text-white transition-colors hover:bg-cta_shadow focus:outline-none focus:ring-2 focus:ring-cta/35 disabled:pointer-events-none disabled:opacity-50"
      onClick={handleClick}
      disabled={disabled}
    >
      {icon && <span>{icon}</span>}
      <span>{text}</span>
    </button>
  )
};

const QuickActions: React.FC = () => {
  const actions = [
    { icon: <RiAddLine className="w-6 h-6 text-white" />, text: "Nieuwe koppeling", route: "/nieuwe-koppeling", disabled: isReadOnly },
    { icon: <RiShieldCheckLine className="w-6 h-6 text-white" />, text: "Authenticatie", route: "/authenticatie" },
  ];

  return (
    <div className="flex overflow-hidden flex-col flex-1 shrink px-4 py-6 bg-white rounded-2xl basis-0 min-h-[240px] min-w-[240px] shadow-[0px_4px_8px_rgba(0,0,0,0.1),0px_2px_4px_rgba(0,0,0,0.06)]">
      <div className="flex flex-col w-full text-base font-semibold leading-none text-gray-900">
        <div className="flex gap-3 items-start w-full">
          <div className="flex-1 shrink w-full min-w-[240px]">Snelkoppelingen</div>
        </div>
      </div>
      <div className="flex flex-col items-start mt-6 w-full text-sm font-medium leading-6 text-white rounded-2xl">
        {actions.map((action, index) => (
          <ActionButton
            key={index}
            icon={action.icon}
            text={action.text}
            route={action.route}
            onClick={action.onClick}
            disabled={action.disabled}
          />
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
